import { render } from "./PatientPage.vue?vue&type=template&id=40c7010a&ts=true"
import script from "./PatientPage.vue?vue&type=script&lang=ts"
export * from "./PatientPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Dashboard/Patient/PatientPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "40c7010a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('40c7010a', __exports__)) {
    api.reload('40c7010a', __exports__)
  }
  
  module.hot.accept("./PatientPage.vue?vue&type=template&id=40c7010a&ts=true", () => {
    api.rerender('40c7010a', render)
  })

}


export default __exports__